












































































import Vue from 'vue'
import Drawer from '@/components/Global/Drawer.vue'
import { rules, defaultUser } from '@/components/Users/constants'
import { mutations } from '@/state'
import { apiCreateUser } from '@/api'

export default Vue.extend({
  name: 'AddUserDrawer',
  components: { Drawer },
  props: {
    loggedInUserObject: {},
    addUserDrawerOpened: Boolean,
    selectedBusiness: {
      type: [Boolean, Object],
      default: false
    },
    businesses: Array,
    roles: Array
  },
  data () {
    return {
      drawerActive: false,
      newUser: { ...defaultUser },
      rules
    }
  },
  methods: {
    close () {
      this.$emit('closeDrawer')
    },
    async createUser () {
      if (!this.$refs.form.validate()) return
      const { firstName, lastName, address, postcode, city, phone, email, role, business, password } = this.newUser
      const data = {
        first_name: firstName,
        last_name: lastName,
        role_name: role.name,
        business_id: business.id,
        address,
        postcode,
        city,
        phone,
        email,
        password
      }

      try {
        mutations.setSnackbar()
        await apiCreateUser(data)
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
        this.newUser = {}
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      } finally {
        this.close()
        this.$emit('initialize')
      }
    }
  },
  mounted () {
    if (this.selectedBusiness) {
      const { id, name } = this.selectedBusiness
      this.newUser.business = { id, name }
    } else {
      this.newUser.business = {
        name: this.loggedInUserObject.sub_vendor_name,
        id: this.loggedInUserObject.parent_id
      }
    }
  },
  watch: {
    addUserDrawerOpened (val) {
      if (val) this.newUser.password = this.generatePassword()
      this.drawerActive = val
    },
    selectedBusiness (val) {
      if (val) {
        const { id, name } = val
        this.newUser.business = { id, name }
      }
    }
  }
})
